import { styled } from 'styled-system/jsx'

const Wrap = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    paddingX: '12px',
    paddingY: '10px',
    borderRadius: 'md',
    border: '1.5px dashed',
    borderColor: 'quickpass.primarySoft',
    backgroundColor: 'quickpass.surfaceCool',
  },
})

const Eyebrow = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: 'quickpass.primary',
  },
})

const TopRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
    flexWrap: 'wrap',
  },
})

const Reasoning = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.ink',
    margin: '0',
    lineHeight: '1.45',
  },
})

const Actions = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
  },
})

const PrimaryButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.primary',
    border: 'none',
    borderRadius: 'pill',
    paddingX: '12px',
    paddingY: '5px',
    cursor: 'pointer',
    transition: 'transform {durations.fast} {easings.appleStandard}',
    _hover: { transform: 'translateY(-1px)' },
    _disabled: {
      opacity: '0.5',
      cursor: 'not-allowed',
      _hover: { transform: 'none' },
    },
  },
})

const TextButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '0',
    transition: 'color {durations.fast} {easings.appleStandard}',
    _hover: { color: 'quickpass.primary' },
  },
})

const Pill = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    color: '#FFFFFF',
    paddingX: '10px',
    paddingY: '3px',
    borderRadius: 'pill',
  },
  variants: {
    suggestion: {
      yes: { backgroundColor: 'quickpass.success' },
      maybe: { backgroundColor: 'quickpass.celebration', color: '#7B5A1A' },
      no: { backgroundColor: 'quickpass.warmth' },
    },
  },
  defaultVariants: {
    suggestion: 'maybe',
  },
})

const ErrorLine = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.warmth',
    fontWeight: '600',
  },
})

const StatusText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    fontStyle: 'italic',
  },
})

export {
  Wrap,
  Eyebrow,
  TopRow,
  Reasoning,
  Actions,
  PrimaryButton,
  TextButton,
  Pill,
  ErrorLine,
  StatusText,
}
